import ProductCard from "./ProductCard";

function Products({ products, onViewImage }) {
  return (
    <section className="section" id="products">
      <div className="section-heading">
        <span>Products</span>
        <h2>Accessories, charms, and custom pieces.</h2>
      </div>

      <div className="products-grid">
        {products.map((product) => (
          <ProductCard
            key={product.name}
            product={product}
            onViewImage={onViewImage}
          />
        ))}
      </div>
    </section>
  );
}

export default Products;